<div class="address-container">
  <form [formGroup]="form" class="address-group">
    <div class="address-title-and-closed">
      <p class="title">{{ titleModal }}</p>
      <button class="btn btn-close" (click)="cancel()">
        <img src="../../../../assets/svgs/close_btn.svg" alt="Fechar" />
      </button>
    </div>

    <div class="row mrg-30">
      <div class="col col-3x2">
        <app-input
          id="ppt-name"
          [label]="'Nome completo *'"
          formControlName="name"
          [messageError]="'Nome requerido'"
          [error]="form.get('name').invalid"
          [placeholder]="''"
        ></app-input>
      </div>
    </div>

    <div class="row">
      <div class="col col-3">
        <app-input
          class="input-control"
          id="ppt-email"
          [label]="'E-mail *'"
          formControlName="email"
          [messageError]="'E-mail requerido'"
          [error]="form.get('email').invalid"
          [placeholder]="'Ex: cliente@e-mail.com.br'"
        ></app-input>
      </div>
      <div class="col col-3">
        <app-input
          class="input-control"
          id="ppt-cpf"
          [label]="'CPF *'"
          formControlName="cpf"
          [messageError]="'CPF requerido'"
          [error]="form.get('cpf').invalid"
          [placeholder]="'Ex: 000.000.000-00'"
        ></app-input>
      </div>

      <div class="col col-3">
        <app-input
          class="input-control"
          id="ppt-rg"
          [label]="'RG *'"
          formControlName="rg"
          [messageError]="'RG requerido'"
          [error]="form.get('rg').invalid"
          [placeholder]="'00.000.000.00'"
        ></app-input>
      </div>
    </div>

    <div class="row mrg-30">
      <div class="col col-3 phone">
        <label for="phone-main">Telefone Principal</label>
        <app-flag-input
          id="phone-main"
          [phone]="form.get('phone_main').value"
          (changes)="changesPhoneMain($event)"
        ></app-flag-input>
      </div>
    </div>

    <div
      class="row mrg-30"
      *ngFor="let item of phonesAlternative; let i = index"
    >
      <div class="col col-3 phone">
        <label for="phone-main">Telefone Alternative</label>
        <app-flag-input
          [phone]="item"
          (changes)="changesPhone($event, i)"
        ></app-flag-input>
      </div>
    </div>

    <div class="input-control mrg-30">
      <button class="btn-add-phone btn" (click)="addPhoneAlternative()">
        Adicionar Telefone
      </button>
    </div>

    <div class="button-container">
      <button class="btn btn-cancel" (click)="cancel()">Cancelar</button>
      <button class="btn btn-continue" (click)="sendItem()">Adicionar</button>
    </div>
  </form>
</div>
